export const IS_DEBUG = process.env.NODE_ENV !== 'production';
export const splitByThousands = (value) => (value === undefined ? '-' : value.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1,'));

export const convertSnakeToCamel = (source) => (
  source.split('_')
    .map((e, index) => (index === 0 ? e : e.charAt(0).toUpperCase() + e.slice(1)))
    .join('')
);

export const convertObjectKeysSnakeToCamel = (target) => {
  if (target === null || target === undefined) {
    return target;
  } if (Array.isArray(target)) {
    return target.map((e) => convertObjectKeysSnakeToCamel(e));
  } if (target instanceof Object) {
    const newObj = {};
    Object.keys(target)
      .forEach((key) => {
        newObj[convertSnakeToCamel(key)] = convertObjectKeysSnakeToCamel(target[key]);
      });
    return newObj;
  }
  return target;
};

export const FREE_TRIAL_PC_RENTAL_ID = 42;
export const SCHOOL_UNSNSBSCRIBE_REASON_OTHER_ID = 99;
export const SCHOOL_SUSPEND_REASON_OTHER_ID = 99;
export const SCREEN_SM = 576;
